import React from "react";

// Enables code splitting the very large okta widget (about 1.3MB or 300KB gzipped) out of the primary bundle
export const OktaWidgetInlineLazy = React.lazy(async () => {
  const module = import("./OktaWidgetInline").then(async (mod) => {
    return { default: mod.OktaWidgetInline };
  });

  return module;
});
